export const measureDotsHeight = (sliderNode, emblaApi) => {
    const dotsNode = sliderNode.querySelector('.embla__dots');
    if (!dotsNode) return;

    const measureAndSetHeight = () => {
        const dotsHeight = dotsNode.offsetHeight;
        sliderNode.style.setProperty('--dots-height', `${dotsHeight}px`);
    };

    // Mede na inicialização, no redimensionamento e no reInit do Embla
    measureAndSetHeight();
    window.addEventListener('resize', measureAndSetHeight);
    emblaApi.on('reInit', measureAndSetHeight);
};